import { render, staticRenderFns } from "./ActionEvent.vue?vue&type=template&id=28408c26&"
import script from "./ActionEvent.vue?vue&type=script&lang=js&"
export * from "./ActionEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports